// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallIncoming24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.8584 16.9023C15.3557 16.9023 15.7588 16.4992 15.7588 16.002C15.7588 15.5047 15.3557 15.1016 14.8584 15.1016L10.1721 15.1016L16.6384 8.63537C16.99 8.28375 16.99 7.71367 16.6384 7.36205C16.2868 7.01044 15.7167 7.01044 15.3651 7.36205L8.89882 13.8283L8.89882 9.14203C8.89882 8.64477 8.49571 8.24167 7.99845 8.24167C7.50119 8.24167 7.09809 8.64477 7.09809 9.14203L7.09809 16.002C7.09809 16.1299 7.12476 16.2516 7.17285 16.3618C7.21167 16.4509 7.26562 16.5351 7.33469 16.6103C7.35171 16.6289 7.36948 16.6467 7.38798 16.6638C7.46589 16.7358 7.55342 16.7914 7.64622 16.8308C7.75441 16.8769 7.87346 16.9023 7.99845 16.9023L14.8584 16.9023Z"
				/>
			</Svg>
		);
	}
);
SvgCallIncoming24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallIncoming24;
